import { Component, ChangeDetectionStrategy, input, output, linkedSignal } from '@angular/core';
import { DiseaseProfile } from '../../../disease-profiles/models';
import { SearchResult } from '../../../search/models';
import { IconComponent } from '@teamfoster/sdk/icon';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { UrlRewritePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-search-result-list',
  templateUrl: './search-result-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RouterLink, DatePipe, FromDictionaryPipe, UrlRewritePipe],
})
export class SearchResultListComponent {
  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly searchResults = input.required<SearchResult[] | DiseaseProfile[]>();
  readonly loading = input<boolean>();
  readonly maxResults = input<number>(0);
  readonly externalUrl = input('');
  readonly chosen = output<boolean>();

  shownResult = linkedSignal(this.maxResults);

  get showLoadMore() {
    return this.shownResult() < this.searchResults().length;
  }

  get localSearchResults() {
    if (this.maxResults()) {
      return this.searchResults().slice(0, this.shownResult());
    }
    return this.searchResults();
  }

  loadMore() {
    this.shownResult.set(this.shownResult() + 10);
  }

  asAny(result: SearchResult | DiseaseProfile): any {
    return result as any;
  }
}
